import { render, staticRenderFns } from "./LoansList.vue?vue&type=template&id=e9e96a6c"
import script from "./LoansList.vue?vue&type=script&lang=js"
export * from "./LoansList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports